import LOCALES from "../../common/locales";
import SafeHtml from "../../common/SafeHtml";
import "./privacyNoticePage.css";

const PRIVACY_NOTICE_SECTION_KEYS = [
  "ACKNOWLEDGE_ONE",
  "ACKNOWLEDGE_TWO",
  "ACKNOWLEDGE_THREE",
  "ACKNOWLEDGE_FOUR",
  "ACKNOWLEDGE_FIVE",
  "ACKNOWLEDGE_SIX",
  "ACKNOWLEDGE_SEVEN",
  "ACKNOWLEDGE_EIGHT",
  "ACKNOWLEDGE_NINE",
  "ACKNOWLEDGE_TEN",
  "ACKNOWLEDGE_ELEVEN",
  "ACKNOWLEDGE_TWELVE",
];

export function PrivacyNoticePage() {
  return (
    <div className="chat-privacy-notice">
      <header className="chat-privacy-notice__header">
        <div className="chat-privacy-notice__header-left">
          <div className="chat-privacy-notice__logo" aria-hidden="true">
            EY
          </div>
          <p className="chat-privacy-notice__header-title">Privacy Notice</p>
        </div>
        <p className="chat-privacy-notice__header-product">EY-P Data Bureau Service</p>
      </header>

      <main className="chat-privacy-notice__body">
        <section className="chat-privacy-notice__card" aria-labelledby="chat-privacy-notice-title">
          <div className="chat-privacy-notice__scroll-content">
            <h1 id="chat-privacy-notice-title" className="chat-privacy-notice__title">
              Privacy Notice - EY-P Data Bureau Service
            </h1>
            <div className="chat-privacy-notice__content">
              {PRIVACY_NOTICE_SECTION_KEYS.map((sectionKey) => (
                <SafeHtml
                  key={sectionKey}
                  as="div"
                  className={`chat-privacy-notice__text ${
                    sectionKey === "ACKNOWLEDGE_SIX" ? "chat-privacy-notice__table-wrap" : ""
                  }`}
                  html={(LOCALES.ACKNOWLEDGE_MODAL[sectionKey] || "").replace(/\n/g, "")}
                />
              ))}
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}

export default PrivacyNoticePage;
